import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-shortcut-command.tsx
/**
* icon.16.shortcut.command
*
* Keywords: cloverleaf, command-key, keyboard-modifier, looped-square, four-leaf, intersecting-loops, mac
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEwLjI1IDRhMS43NSAxLjc1IDAgMSAxIDAgMy41SDkuNXYxaC43NWExLjc1IDEuNzUgMCAxIDEtMS43NSAxLjc1VjkuNWgtMXYuNzVBMS43NSAxLjc1IDAgMSAxIDUuNzUgOC41aC43NXYtMWgtLjc1QTEuNzUgMS43NSAwIDEgMSA3LjUgNS43NXYuNzVoMXYtLjc1YzAtLjk2Ni43ODQtMS43NSAxLjc1LTEuNzVtLTQuNSA1LjVhLjc1Ljc1IDAgMSAwIC43NS43NVY5LjV6bTMuNzUuNzVhLjc1Ljc1IDAgMSAwIC43NS0uNzVIOS41em0tMi0xLjc1aDF2LTFoLTF6TTUuNzUgNWEuNzUuNzUgMCAwIDAgMCAxLjVoLjc1di0uNzVBLjc1Ljc1IDAgMCAwIDUuNzUgNW00LjUgMGEuNzUuNzUgMCAwIDAtLjc1Ljc1di43NWguNzVhLjc1Ljc1IDAgMCAwIDAtMS41Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=23493-54442
*/
const Icon16ShortcutCommand = memo(function Icon16ShortcutCommand(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M10.25 4a1.75 1.75 0 1 1 0 3.5H9.5v1h.75a1.75 1.75 0 1 1-1.75 1.75V9.5h-1v.75A1.75 1.75 0 1 1 5.75 8.5h.75v-1h-.75A1.75 1.75 0 1 1 7.5 5.75v.75h1v-.75c0-.966.784-1.75 1.75-1.75m-4.5 5.5a.75.75 0 1 0 .75.75V9.5zm3.75.75a.75.75 0 1 0 .75-.75H9.5zm-2-1.75h1v-1h-1zM5.75 5a.75.75 0 0 0 0 1.5h.75v-.75A.75.75 0 0 0 5.75 5m4.5 0a.75.75 0 0 0-.75.75v.75h.75a.75.75 0 0 0 0-1.5"
		})
	});
});
//#endregion
export { Icon16ShortcutCommand };

//# sourceMappingURL=icon-16-shortcut-command.js.map